import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailKvReadOnly,
    DetailKvTable,
    DetailPanel,
    DetailSummaryButton,
} from "../../../../components/detailLayout";
import React from "react";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import Th_title from "../../../../components/Th_title";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {ContentCategory, ContentStatus} from "../../../../constant/CodeSpecNum";
import ApprovalComponent from "../../../settings/approval/new/ApprovalComponent";
import {IntroductionVerification} from "./IntroductionVerification";
import {IntroductionAssetDraftList} from "../components/IntroductionAssetDraftList";
import {useDispatch, useSelector} from "react-redux";
import {assetIntroduction, removeIntroductions} from "../../../../api/lifecycle/introduction/IntroductionService";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {changeRefreshContentStatus} from "../../../../redux/slice/statusSlice";
import {apiLoading} from "../../../../redux/slice/apiSlice";
import {isMobile} from "../../../../components/commonmethod/CommonMethod";
import {useNavigate} from "react-router-dom";

function IntroductionInfo({id, introduction, statusNumericValue}) {
    const license = useSelector((state) => state.auth.license);
    const parts = license?.split("_");
    const assetExceed = parts?.some((part) => part.includes("ASSET"));
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const remove = async () => {
        const response = await removeIntroductions({ids: [id]});
        if (response.status === 200) {
            alert("자산도입이 정상적으로 삭제되었습니다.");
            navigate("/lifecycle/introduction");
        }
    };

    const canAccept =
        introduction.auth?.update &&
        statusNumericValue === ContentStatus.PRE_INSERT.statusNumericValue;

    async function handleAssetIntroduction(item) {
        if (license === "PASS" || !assetExceed) {
            dispatch(apiLoading(true));
            await assetIntroduction({...item, introduction: {id: introduction.id}})
                .then((response) => {
                    if (response.status === 200) {
                        dispatch(changeRefreshContentStatus());
                        handleActiveToast({message: "자산이 도입되었습니다."});
                    } else if (response.status === 201 || response.status === 202) {
                        handleActiveError({
                            message: response.data.title,
                            description: response.data.reason,
                        });
                    } else {
                        handleActiveError({message: "알 수 없는 에러 발생."});
                    }
                })
                .finally(() => dispatch(apiLoading(false)));
        } else {
            alert("자산 라이센스 수량이 초과됩니다.\n 자산수량을 확인해주세요");
        }
    }

    const summaryMeta = [
        introduction.requestCode?.name && `종류 ${introduction.requestCode.name}`,
        introduction.number && `번호 ${introduction.number}`,
    ]
        .filter(Boolean)
        .join(" · ");

    const requestInfoPanel = (
        <DetailPanel title="요청정보">
            <DetailKvTable>
                <tbody>
                    <tr>
                        <DetailKvReadOnly label="등록일시" value={introduction.createdAt} type="date" />
                        <DetailKvReadOnly label="수정일시" value={introduction.updatedAt} type="date" />
                    </tr>
                    <tr>
                        <DetailKvReadOnly label="등록자" value={introduction.createdBy?.name} />
                        <DetailKvReadOnly label="수정자" value={introduction.updatedBy?.name} />
                    </tr>
                    <tr>
                        <Th_title title="요청자" colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target="requester" value={introduction.requester?.name} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="요청종류" colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target="requestCode" value={introduction.requestCode?.name} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="요청일" colspan={3} className="fieldset-td fieldset-td-input">
                            <div className="web-flex asset-detail-date-range">
                                <SimmsDatePicker data={introduction.requestStartDate} readonly />
                                <span className="asset-detail-date-range-sep">~</span>
                                <SimmsDatePicker data={introduction.requestEndDate} readonly />
                            </div>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="요청번호" colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target="number" value={introduction.number} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="검수자" colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target="inspector" value={introduction.inspector?.name} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="제목" colspan={3} className="fieldset-td">
                            <ReadOnlyInputBasic target="name" value={introduction.name} />
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title="내용" colspan={3} className="fieldset-td">
                            <div className="align-text-div">{introduction.content}</div>
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title="기타" colspan={3} className="fieldset-td">
                            <div className="align-text-div">{introduction.etc}</div>
                        </Th_title>
                    </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const assetInfoPanel = (
        <>
            <DetailPanel title="자산정보">
                <DetailKvTable>
                    <tbody>
                        <tr>
                            <Th_title title="운영담당자" colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target="operator" value={introduction.operator?.name} />
                            </Th_title>
                        </tr>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title="자산내역" colspan={3} className="fieldset-td align-top">
                                <IntroductionAssetDraftList
                                    assets={introduction.assets}
                                    readonly
                                    emptyText="등록된 도입자산이 없습니다."
                                    renderTrailing={(item) => {
                                        if (statusNumericValue !== ContentStatus.COMPLETE.statusNumericValue) {
                                            return null;
                                        }
                                        if (!item.introductionDate) {
                                            return (
                                                <button
                                                    type="button"
                                                    className="introduction-asset-draft__action"
                                                    onClick={() => handleAssetIntroduction(item)}
                                                >
                                                    도입
                                                </button>
                                            );
                                        }
                                        return (
                                            <span className="introduction-asset-draft__status">
                                                도입완료 · {item.introductionDate}
                                            </span>
                                        );
                                    }}
                                />
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
            <IntroductionVerification data={introduction} />
        </>
    );

    const asidePanel = (
        <>
            <ApprovalComponent
                contentId={introduction.id}
                contentCategory={ContentCategory.INTRODUCTION}
            />
            <DetailFilePanel
                title="첨부"
                isEditing={Boolean(introduction.auth?.update)}
                tableInfo={{tableName: "introduction", joinKey: introduction.id}}
            />
        </>
    );

    return (
        <ContentDetailInfoShell
            title={introduction.name || "자산도입 상세"}
            meta={summaryMeta || undefined}
            contentId={id}
            contentCategory={ContentCategory.INTRODUCTION}
            scrollMode="columns"
            listUrl="/lifecycle/introduction"
            actions={
                canAccept ? (
                    <DetailSummaryButton onClick={() => navigate(`/lifecycle/introduction/update/${id}`)}>
                        접수하기
                    </DetailSummaryButton>
                ) : null
            }
            rollup={{
                remove:
                    !isMobile &&
                    introduction.auth?.delete &&
                    statusNumericValue !== ContentStatus.COMPLETE.statusNumericValue
                        ? remove
                        : "",
            }}
        >
            <ContentDetailThreeColLayout
                primary={requestInfoPanel}
                secondary={assetInfoPanel}
                aside={asidePanel}
            />
        </ContentDetailInfoShell>
    );
}

export {IntroductionInfo};
